import { homeRoleRoutes, builderRoleRoutes, constantRoutes } from "@/router";
import { getRoleId } from "@/utils/auth";

const state = {
  routes: [],
  addRoutes: [],
};

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes;
    state.routes = routes;
  },
  RESET_ROUTES: (state) => {
    state.addRoutes = [];
    state.routes = [];
  },
};

const actions = {
  generateRoutes({ commit }) {
    return new Promise((resolve) => {
      //生成新的显示路由数组
      let displayRoutes = homeRoleRoutes;
      const roleId = getRoleId();
      if (roleId === "0") {
        displayRoutes = builderRoleRoutes;
      }

      // 合并 constantRoutes 和角色路由，然后按 order 字段排序
      const allRoutes = [
        ...constantRoutes.filter((route) => !route.hidden),
        ...displayRoutes,
      ];
      const sortedRoutes = allRoutes.sort((a, b) => {
        const orderA = a.meta && a.meta.order ? a.meta.order : 999;
        const orderB = b.meta && b.meta.order ? b.meta.order : 999;
        return orderA - orderB;
      });

      console.log("生成新的显示路由数组", sortedRoutes);
      commit("SET_ROUTES", sortedRoutes);
      resolve(sortedRoutes);
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
